export default __webpack_public_path__ + "c69f70037a8e83cbdc88e63bd51cb6fd.png";